export const baseFileTypes = [
  "application/pdf",
  "image/jpg",
  "image/jpeg",
  "image/png",
];
